import { OverlayContainer } from '@angular/cdk/overlay';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { BehaviorSubject } from 'rxjs';

export interface MinimizedDialog {
  data: any;
  dialogId: string;
  ref: MatDialogRef<any>;
  status: 'in-progress' | 'completed';
}

@Injectable({
  providedIn: 'root',
})
export class MxTaskbarService {
  private minimizedDialogsSubject = new BehaviorSubject<MinimizedDialog[]>([]);
  public minimizedDialogs$ = this.minimizedDialogsSubject.asObservable();
  private minimizedDialogs: MinimizedDialog[] = [];

  constructor(private dialog: MatDialog, private overlayContainer: OverlayContainer) {}

  openMxDialog(component: any, config?: any): MatDialogRef<any> {
    const dialogId = `mx-${Date.now()}`;
    config = { ...config, data: { ...(config?.data || {}), dialogId }, panelClass: 'mx-connect-window-dialog' };
    const dialogRef = this.dialog.open(component, config);

    if ((dialogRef.componentInstance as any)?.dialogId !== undefined) {
      (dialogRef.componentInstance as { dialogId: string }).dialogId = dialogId;
    }

    const dialogBackdrops = this.overlayContainer.getContainerElement().querySelectorAll('.cdk-overlay-backdrop');
    if (dialogBackdrops.length > 0) {
      dialogBackdrops[dialogBackdrops.length - 1].setAttribute('data-dialog-id', dialogId);
      // dialogBackdrops[dialogBackdrops.length - 1].setAttribute('style', 'z-index: 100001;');
      // const dialogOverlayWrapper = this.overlayContainer.getContainerElement().querySelectorAll('.cdk-global-overlay-wrapper');
      // dialogOverlayWrapper[dialogBackdrops.length - 1]?.setAttribute('style', 'z-index: 1000001;');
    }
    dialogRef.afterClosed().subscribe(() => {});

    return dialogRef;
  }

  minimizeMxDialog(ref: MatDialogRef<any>, dialogId: string, institutionName = '') {
    const dialogIndex = this.minimizedDialogs.findIndex((d) => d.dialogId === dialogId);
    if (dialogIndex === -1) {
      const dialogBackdrop = this.overlayContainer.getContainerElement().querySelector(`.cdk-overlay-backdrop[data-dialog-id="${dialogId}"]`);
      ref.addPanelClass('app__minimize--Dialog');
      if (dialogBackdrop) (dialogBackdrop as HTMLElement).style.display = 'none';
      // const dialogElement = document.querySelector(`.cdk-overlay-pane[data-dialog-id="${dialogId}"]`);
      // if (dialogElement) dialogElement.classList.add('app__minimize--Dialog');
      this.minimizedDialogs.push({
        ref,
        data: { refData: ref.componentInstance.data, institutionName: ref?.componentInstance?.selected_institution_data?.name ?? institutionName },
        dialogId,
        status: 'in-progress',
      });
      this.updateMinimizedDialogs();
    }
  }

  maximizeMxDialog(ref: MatDialogRef<any>, dialogId: string) {
    const dialogIndex = this.minimizedDialogs.findIndex((dialog) => dialog.dialogId === dialogId);
    if (dialogIndex !== -1) {
      ref.removePanelClass('app__minimize--Dialog');
      this.minimizedDialogs.splice(dialogIndex, 1);
      const dialogBackdrop = this.overlayContainer.getContainerElement().querySelector(`.cdk-overlay-backdrop[data-dialog-id="${dialogId}"]`);
      if (dialogBackdrop) (dialogBackdrop as HTMLElement).style.display = 'block';
      this.updateMinimizedDialogs();
    }
  }

  getMinimizedDialogs(): MinimizedDialog[] {
    return this.minimizedDialogs;
  }

  clearMinimizedDialogs(): void {
    this.minimizedDialogs = [];
    this.updateMinimizedDialogs();
  }

  private updateMinimizedDialogs() {
    this.minimizedDialogsSubject.next(this.minimizedDialogs);
  }

  updateMxConnectionStatus(ref: MatDialogRef<any>, dialogId: string, status: 'in-progress' | 'completed', institutionName = null) {
    const index = this.minimizedDialogs.findIndex((d) => d.dialogId === dialogId);
    if (index !== -1) {
      this.minimizedDialogs[index].status = status;
      if (institutionName != null) {
        this.minimizedDialogs[index].data.institutionName = institutionName;
      }
      this.updateMinimizedDialogs();
    }
  }
}
